export default "__VITE_ASSET__4cfa9fec__"